import * as React from 'react'

import { Controller } from 'react-hook-form'

import { cn } from '@/lib/utils'

import { Checkbox } from '../../shadcn-ui/checkbox'
import { CheckboxFieldConfig } from '../types'

interface CheckboxFieldProps {
  field: CheckboxFieldConfig
  control: any
  error?: string
  hideHelperText?: boolean
}

export default function CheckboxField({ field, control }: CheckboxFieldProps) {
  const isDisabled = !!(field.disabled || field.readOnly)
  return (
    <Controller
      name={field.name}
      control={control}
      defaultValue={field.defaultValue ?? false}
      render={({ field: { onChange, value } }) => (
        <div className="tw:grid tw:items-center tw:min-h-14 tw:px-2">
          <label
            className={cn(
              'tw:inline-flex tw:items-center tw:gap-2 tw:cursor-pointer tw:select-none',
              field.displayOnly && 'tw:cursor-default',
            )}
          >
            <Checkbox
              checked={!!value}
              disabled={isDisabled}
              displayOnly={field.displayOnly}
              onCheckedChange={
                field.displayOnly ? undefined : checked => onChange(checked)
              }
            />
            <span>{field.label || field.name}</span>
          </label>
        </div>
      )}
    />
  )
}
